import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Dialog, DialogContent } from "../ui/dialog";
import { CalendarPlus, X } from "lucide-react";
import { EventCalendarView } from "./events/EventCalendarView";
import { EventForm } from "./events/EventForm";
import { EventListItem } from "./events/EventListItem";
import { useEventCRUD } from "../../hooks/useEventCRUD";

export const AdminEvents = ({ onEventsChanged }) => {
  const {
    events, selectedDate, setSelectedDate, filteredEvents,
    dialogOpen, setDialogOpen, form, setForm, editingId, saving,
    openCreate, openEdit, submit, remove, resetForm,
  } = useEventCRUD(onEventsChanged);

  return (
    <Card className="p-6 space-y-6" data-testid="admin-events-panel">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h3 className="font-semibold">Calendario de Eventos</h3>
        <Button data-testid="event-open-create" onClick={openCreate}>
          <CalendarPlus size={16} className="mr-2" /> Nuevo evento
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-6">
        <EventCalendarView events={events} selectedDate={selectedDate} onSelectDate={setSelectedDate} />

        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <p className="text-sm font-medium">
              {selectedDate
                ? `Eventos del ${selectedDate.toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" })}`
                : "Todos los eventos"}
            </p>
            {selectedDate && (
              <Button data-testid="event-clear-filter" size="sm" variant="ghost" onClick={() => setSelectedDate(null)}>
                <X size={14} className="mr-1" /> Ver todos
              </Button>
            )}
          </div>

          {filteredEvents.length === 0 ? (
            <p data-testid="admin-events-empty" className="text-sm text-muted-foreground">
              No hay eventos {selectedDate ? "en esta fecha" : "registrados todavía"}.
            </p>
          ) : (
            <div className="space-y-3 max-h-[520px] overflow-y-auto pr-1">
              {filteredEvents.map((event) => (
                <EventListItem
                  key={event.id}
                  event={event}
                  onEdit={() => openEdit(event)}
                  onDelete={() => remove(event.id)}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <Dialog open={dialogOpen} onOpenChange={(v) => { setDialogOpen(v); if (!v) resetForm(); }}>
        <DialogContent data-testid="event-form-dialog">
          <EventForm
            form={form}
            setForm={setForm}
            editingId={editingId}
            saving={saving}
            onSubmit={submit}
            onCancel={() => setDialogOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </Card>
  );
};
